import { render } from "./List.vue?vue&type=template&id=cf7aca4a"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
script.render = render

export default script